"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMainHeader = void 0;
var _material = require("@mui/material");
var _react = require("@emotion/react");
var _react2 = _interopRequireDefault(require("react"));
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
const _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * DmsMainHeader component represents a main header navigation bar.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the header. Should contain Left, Middle, and Right components.
 * @param {string} [props.theme='light'] - The theme of the header. Can be 'light' or 'dark'.
 * @returns {JSX.Element} DmsMainHeader component.
 * 
 * @example
 * <DmsMainHeader>
 *   <DmsMainHeader.Left>
 *     <DmsLogoIcon />
 *     <DmsBarMenuButton onClick={handleClick} />
 *   </DmsMainHeader.Left>
 *   <DmsMainHeader.Middle>
 *     <DmsDateTime />
 *   </DmsMainHeader.Middle>
 *   <DmsMainHeader.Right>
 *     <DmsNotificationsMenuHeader />
 *     <DmsFullScreenButton />
 *     <DmsUserInformation />
 *     <DmsLogout />
 *   </DmsMainHeader.Right>
 * </DmsMainHeader>
 */
const DmsMainHeader = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const leftContent = _react2.default.Children.toArray(children).find(child => child.type === DmsMainHeader.Left);
  const middleContent = _react2.default.Children.toArray(children).find(child => child.type === DmsMainHeader.Middle);
  const rightContent = _react2.default.Children.toArray(children).find(child => child.type === DmsMainHeader.Right);
  const theme = (0, _react.useTheme)();
  return /*#__PURE__*/_react2.default.createElement(_material.AppBar, {
    position: "static",
    sx: {
      bgcolor: theme.palette.blue.main
    }
  }, /*#__PURE__*/_react2.default.createElement(_material.Toolbar, null, /*#__PURE__*/_react2.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react2.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, leftContent === null || leftContent === void 0 ? void 0 : leftContent.props, leftContent), /*#__PURE__*/_react2.default.createElement(_DmsFlexContainer.DmsFlexContainer.Center, middleContent === null || middleContent === void 0 ? void 0 : middleContent.props, middleContent), /*#__PURE__*/_react2.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, rightContent === null || rightContent === void 0 ? void 0 : rightContent.props, rightContent))));
};

/**
 * DmsMainHeader.Left component represents the left content area of the header.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the left area.
 * @returns {JSX.Element} DmsMainHeader.Left component.
 */
exports.DmsMainHeader = DmsMainHeader;
DmsMainHeader.Left = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, children);
};

/**
 * DmsMainHeader.Middle component represents the middle content area of the header.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the middle area.
 * @returns {JSX.Element} DmsMainHeader.Middle component.
 */
DmsMainHeader.Middle = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, children);
};

/**
 * DmsMainHeader.Right component represents the right content area of the header.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the right area.
 * @returns {JSX.Element} DmsMainHeader.Right component.
 */
DmsMainHeader.Right = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, children);
};